import React, { useEffect } from 'react'
import { useUserStorage } from '../../storage/user'
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom'
import { useGlobalCarteira } from '../../storage/globalCarteira';

export default function PerfilButton() {
    
    const user2 = localStorage.getItem("user")
    const user = JSON.parse(user2)

     const { dataCarteira } = useGlobalCarteira(state => state)
 

    const navigate = useNavigate();

    
    return (
        <div onClick={() => { navigate("/painel") }} style={{ display: 'flex', cursor: 'pointer' }}
        >
            {user != null &&
                <>
                    {
                        dataCarteira?.imagem ? <img src={dataCarteira?.imagem} style={{ width: '50px', height: '50px', background: '#3e64de', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50px' }} />
                        :
                        <div style={{ width: '50px', height: '50px', background: '#3e64de', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50px' }}>
                        
                                <h3 style={{ color: 'white' }}>{user?.nome?.charAt(0)}</h3>
                            </div>
                    }

                    <div style={{ marginLeft: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <h4>Olá! </h4>
                        <h3>{user?.nome || ''}</h3>
                    </div>
                </>
            }
 
        </div>
    )
}
